var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPptFile = function SvgPptFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C5.175 0 4.5 0.675 4.5 1.5V22.5C4.5 23.325 5.175 24 6 24H21C21.825 24 22.5 23.325 22.5 22.5V6L16.5 0H6Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H22.5L16.5 0V4.5C16.5 5.325 17.175 6 18 6Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10.5L18 6H22.5V10.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5C19.5 19.9125 19.1625 20.25 18.75 20.25H2.25C1.8375 20.25 1.5 19.9125 1.5 19.5V12C1.5 11.5875 1.8375 11.25 2.25 11.25H18.75C19.1625 11.25 19.5 11.5875 19.5 12V19.5Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9433 14.2104C4.9433 14.0124 5.0993 13.7964 5.35055 13.7964H6.7358C7.5158 13.7964 8.2178 14.3184 8.2178 15.3189C8.2178 16.2669 7.5158 16.7949 6.7358 16.7949H5.73455V17.5869C5.73455 17.8509 5.5673 18.0001 5.3513 18.0001C5.1533 18.0001 4.94405 17.8509 4.94405 17.5869V14.2104H4.9433ZM5.73455 14.5516V16.0456H6.7358C7.1378 16.0456 7.4558 15.6909 7.4558 15.3189C7.4558 14.8996 7.1378 14.5516 6.7358 14.5516H5.73455Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.98206 14.2104C8.98206 14.0124 9.13806 13.7964 9.39006 13.7964H10.7753C11.5553 13.7964 12.2573 14.3184 12.2573 15.3189C12.2573 16.2669 11.5553 16.7949 10.7753 16.7949H9.77406V17.5869C9.77406 17.8509 9.60606 18.0001 9.39006 18.0001C9.19206 18.0001 8.98206 17.8509 8.98206 17.5869V14.2104ZM9.77331 14.5516V16.0456H10.7746C11.1766 16.0456 11.4946 15.6909 11.4946 15.3189C11.4946 14.8996 11.1766 14.5516 10.7746 14.5516H9.77331Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1413 14.6003H13.0928C12.5708 14.6003 12.5708 13.833 13.0928 13.833H15.9285C16.4625 13.833 16.4625 14.6003 15.9285 14.6003H14.9333V17.6288C14.9333 18.15 14.1413 18.1628 14.1413 17.6288V14.6003Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 20.25H4.5V21H18.75C19.1625 21 19.5 20.6625 19.5 20.25V19.5C19.5 19.9125 19.1625 20.25 18.75 20.25Z",
    fill: "#CAD1D8"
  })));
};
export default SvgPptFile;